export default __webpack_public_path__ + "static/media/ARABICA.a50111ab.jpg";